// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S0gI","top":"styles_top__34yAE"};